module.exports = __webpack_public_path__ + "img/050.eb608aad.png";